// extracted by mini-css-extract-plugin
module.exports = {"backdrop":"BackdropBlur_backdrop__5wmA0","modal":"BackdropBlur_modal__37b2x","light":"BackdropBlur_light__2XGlT"};